import React, { Component } from 'react';

import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';

import { analyticsService } from '../../../_services/analytics.service';
import IncomeChartsPerc from './Charts/IncomeChartsPerc';
import IncomeChartsEuro from './Charts/IncomeChartsEuro';
import moment from 'moment';

export default class ECommerceIncome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      incomesStatsPerc: null,
      incomesStatsEuro: null,
      incomesStatsDayPerc: null,
      incomesStatsDayVsDayPerc: null,
    };
  }

  async componentDidMount() {
    const { user, shop, from, to } = this.props;

    if (!!user.id && !!shop.id) {
      try {
        const incomesStatsPerc = await analyticsService.getIncomesStatsPerc(
          user.id,
          shop.id,
          from.toISOString(),
          to.toISOString()
        );

        const incomesStatsEuro = await analyticsService.getIncomesStatsEuro(
          user.id,
          shop.id,
          from.toISOString(),
          to.toISOString()
        );

        const incomesStatsDayPerc = await analyticsService.getIncomesStatsDayPerc(
          user.id,
          shop.id,
          moment().startOf('day').toISOString(),
          moment().startOf('day').toISOString()
        );

        const incomesStatsDayVsDayPerc = await analyticsService.getIncomesStatsDayVsDayPerc(
          user.id,
          shop.id,
          moment().startOf('day').toISOString(),
          moment().subtract(7, 'days').startOf('day').toISOString()
        );

        let cumulativeTotal = 0;
        let cumulativeShop = 0;
        let incrementalIncomesStatsDayVsDayPerc = incomesStatsDayVsDayPerc
          .sort((a, b) => a.data - b.data) // 🔁 Ordina dalla data più vecchia alla più recente
          .map((item) => {
            cumulativeTotal += item.total;
            cumulativeShop += item.shop;

            return {
              data: item.data,
              total: cumulativeTotal,
              shop: cumulativeShop
            };
          });



        await this.setState({ incomesStatsPerc, incomesStatsEuro, incomesStatsDayPerc, incomesStatsDayVsDayPerc, incrementalIncomesStatsDayVsDayPerc });
      } catch (error) {
        console.error(error);
      }
    }

    window.removeLoader();
  }

  render() {
    const { user, shop } = this.props;
    const { incomesStatsPerc, incomesStatsEuro, incomesStatsDayPerc, incomesStatsDayVsDayPerc, incrementalIncomesStatsDayVsDayPerc } = this.state;

    return !user.id || !shop.id ? (
      <Alert color="warning">
        Non hai ancora un negozio associato. <Link to="/shop">Vai al form di creazione.</Link>
      </Alert>
    ) : (
      <div>
        <div className="row">
          <div className="col-12 mT-20">
            <IncomeChartsPerc statsHistory={incomesStatsPerc}
              title='Andamento Fatturato rispetto al Mercato'
              label='Mercato'
              label2='Il tuo negozio'
              desc='Confronto andamento del fatturato del Mercato (escluso il tuo negozio ) Vs il tuo Negozio nel periodo selezionato'
            />
          </div>

          <div className="col-12 mT-20">
            <IncomeChartsPerc statsHistory={incomesStatsDayPerc}
              title='Il tuo Fatturato oggi rispetto al Mercato'
              label='Mercato Oggi'
              label2='Il tuo negozio Oggi'
              desc='Confronto andamento del fatturato Mercato (escluso il tuo negozio ) con il tuo Negozio oggi'
            />
          </div>

          <div className="col-6 mT-20">
            <IncomeChartsPerc statsHistory={incomesStatsDayVsDayPerc}
              title='Il tuo Fatturato oggi vs 7 giorni fa'
              label='Il tuo negozio 7 giorni fa'
              label2='Il tuo negozio Oggi'
              desc='Confronto andamento del tuo negozio 7 giorni fa con il tuo Negozio oggi'
            />
          </div>

          <div className="col-6 mT-20">
            <IncomeChartsPerc statsHistory={incrementalIncomesStatsDayVsDayPerc}
              title='Il tuo Fatturato oggi vs 7 giorni fa - incrementale'
              label='Il tuo negozio 7 giorni fa'
              label2='Il tuo negozio Oggi'
              desc='Confronto andamento del tuo negozio 7 giorni fa con il tuo Negozio oggi'
            />
          </div>

          <div className="col-12 mT-20">
            <IncomeChartsEuro statsHistory={incomesStatsEuro} />
          </div>
          <small>
            <p>
              I valori visualizzati in percentuale sono indicativi dell'andamento del fatturato e non del valore. <br />
              Il valore visualizzato è proporzionale al massimo nel periodo visualizzato.
              <b>
                Obiettivo di questo grafico è fornire una rappresentazione dell'andamento del Fatturato Totale e di quello
                del prorpio e-commerce in termini qualitativi e non quantitativi.
              </b>
            </p>
          </small>
        </div>
      </div>
    );
  }
}
